import { Component } from '@angular/core';

@Component({
  selector: 'ez-deleted-applicant',
  templateUrl: './deleted-applicant.component.html',
  styleUrls: ['./deleted-applicant.component.scss'],
  standalone: false,
})
export class DeletedApplicantComponent { }
